import { MagnifyingGlass } from 'phosphor-react'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { getArticulos, getArticulosByFamily, setBusqueda } from '../../actions/articulos'
import { limpiarFiltros } from '../../actions/filtros'
import { withRouter } from '../../helpers/funciones'
import i18n from '../../lang/idiomas'
import AnalyticsEdisa from '../common/AnalyticsEdisa'

export class Buscador extends Component {
  state = {
    valor: '',
  }

  static propTypes = {
    isLoadingArticulos: PropTypes.bool.isRequired,
    articulos_pagina: PropTypes.number.isRequired,
    articulos_orden: PropTypes.string.isRequired,
    filtros_aplicados: PropTypes.array.isRequired,
    auth: PropTypes.object,
    getArticulos: PropTypes.func.isRequired,
    getArticulosByFamily: PropTypes.func.isRequired,
  }

  onChange = e => {
    this.setState({ [e.target.name]: e.target.value })
  }

  onSubmit = e => {
    e.preventDefault()
    const { valor } = this.state
    let analytics = new AnalyticsEdisa()
    analytics.registraEvento({
      modulo: 'Articulos',
      tipo: 'Search',
      valor: valor.trim(),
    })

    this.props.setBusqueda(valor.trim())

    this.props.limpiarFiltros()

    this.props.getArticulos(
      valor.trim(),
      this.props.articulos_pagina,
      this.props.articulos_orden,
      this.props.pedido.domicilio_envio ? this.props.pedido.domicilio_envio : '',
    )

    this.setState({
      valor: '',
    })

    if (this.props.router && this.props.router.location.pathname !== '/articulos') {
      this.props.router.navigate('/articulos')
    }
  }

  render() {
    const { valor } = this.state
    if (this.props.isLoadingArticulos) {
      document.body.style.cursor = 'wait'
    } else {
      document.body.style.cursor = 'default'
    }
    return (
      <div className='container'>
        <div className='row buscador'>
          <div className='col-md-6'>
            <form
              onSubmit={this.onSubmit}
              className='form-inline form-default justify-content-end pr-3'>
              <div className='input-group'>
                <input
                  className='form-control'
                  type='text'
                  name='valor'
                  placeholder={i18n.t('general.buscar')}
                  onChange={this.onChange}
                  value={valor}
                />
                <div className='input-group-append'>
                  <button
                    type='submit'
                    className='btn btn-primary'
                    disabled={this.props.isLoadingArticulos}>
                    <MagnifyingGlass
                      size={20}
                      weight='bold'
                    />
                    {i18n.t('general.buscar')}
                  </button>
                </div>
              </div>
              {this.props.mostrar_avanzado === 'S' ? (
                <div className='enlace-busqueda-avanzada'>
                  <a
                    onClick={e => {
                      e.preventDefault()
                      this.props.setBusqueda('')
                      this.props.cambiarBuscador()
                    }}
                    href='#'>
                    {i18n.t('general.busavtit')}
                  </a>
                </div>
              ) : (
                ''
              )}
            </form>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  isLoadingArticulos: state.listadoArticulos.articulos.isLoading,
  articulos_pagina: state.listadoArticulos.articulos_pagina,
  articulos_orden: state.listadoArticulos.articulos_orden,
  filtros_aplicados: state.articulos.filtros_aplicados,
  portal: state.portal.portal,
  cookies: state.portal.cookies,
  pedido: state.pedidos.pedido,
})

export default withRouter(
  connect(mapStateToProps, { getArticulos, setBusqueda, getArticulosByFamily, limpiarFiltros })(
    Buscador,
  ),
)
